export const UNIT_DEPLOYMENT_MGR = 'Unit Deployment Mgr';
export const IMMUNIZATION_TECH = 'Immunization Tech';
export const COMMANDER = 'Commander';
export const DEPLOYMENT_PROVIDER_NURSE = 'Deployment Provider/Nurse';
export const PUBLIC_HEALTH_TECH = 'Public Health Tech';
export const LAB_TECH = 'Lab Tech';
export const PHA_TECH = 'PHA Tech';
export const DRHA_TECH = 'DRHA Tech';
export const ADMINISTRATOR = 'Administrator';
export const FOURN_TECH = '4N Technician';
export const PHA_PROVIDER = 'PHA Provider';
export const PHYSICIAN = 'Physician';
export const PHYSICIAN_ASSISTANT = 'Physician Assistant';
export const NURSE_PRACTITIONER = 'Nurse practitioner';
export const REGISTERED_NURSE = 'Registered nurse';
export const TECHNICIAN = 'Technician';
export const VA_RECRUITER = 'Medical Recruiter';
